import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installGlobalErrorLogging } from './utils/errorLogUtil';

// Installed BEFORE the first render so a component that throws on mount is
// captured too — that is exactly the failure an admin has no other way to see
// on a production deployment. Idempotent, and it never throws: see
// utils/errorLogUtil.js for the write guards and the re-entrancy note.
installGlobalErrorLogging();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
